const MainContextDataReducerActionTypes = {
  IS_CALENDLY_OPEN: "IS_CALENDLY_OPEN",
  PLANS_MONTHLY_ANNUALLY_TOGGLE: "PLANS_MONTHLY_ANNUALLY_TOGGLE",
};

export default MainContextDataReducerActionTypes;
